__turbopack_context__.v({
  "Price": "SupporterModal-module__Cao26G__Price",
  "bgCircle": "SupporterModal-module__Cao26G__bgCircle",
  "bgLight": "SupporterModal-module__Cao26G__bgLight",
  "bgPrimary": "SupporterModal-module__Cao26G__bgPrimary",
  "borderStyle": "SupporterModal-module__Cao26G__borderStyle",
  "card": "SupporterModal-module__Cao26G__card",
  "closeIcon": "SupporterModal-module__Cao26G__closeIcon",
  "communityBadge": "SupporterModal-module__Cao26G__communityBadge",
  "overlay": "SupporterModal-module__Cao26G__overlay",
  "titleText": "SupporterModal-module__Cao26G__titleText",
  "toggleBtn": "SupporterModal-module__Cao26G__toggleBtn",
  "toggleBtnGroup": "SupporterModal-module__Cao26G__toggleBtnGroup",
});
